import { Box, Button, Grid, Typography } from "@mui/material";
import CardSys from "../cardSys";
import CloseButton from "../generic/closeButton";
import SubTitlePages from "../generic/subTitlePages";
import CancelButton from "../generic/cancelButton";
import ButtonSave from "../buttonSave";
import { useContext, useEffect, useRef, useState } from "react";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { api } from "../../services/api";
import InputFile from "../generic/inputFile";
import { apiUrl } from "../../services/apiUrl";
import Resizer from "react-image-file-resizer";


export default function LogoClients({ logo, handleClose, updateTable, id, title, logoImg }) {
  const [avatarUrl, setAvatarUrl] = useState(!!logo ? `${apiUrl}/files/${logo}` : '');
  const [imageAvatar, setImageAvatar] = useState(null);
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!imageAvatar) {
      handleToast(true, "warning", "Nenhuma alteração feita")
      return
    }

    handleLoading(true); 
    const body = new FormData();
    body.append("logo_img", "teste.png")
    body.append("profilePic", imageAvatar)
    body.append("id_client", id)

    try {
      const { data } = await api({
        method: "post",
        url: "/logo/upload",
        data: body
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    updateTable()
    handleClose()
  };

  async function handleFile(e) {
    if (!e.target.files) {
      setAvatarUrl('')
      return;
    }
    let image = e.target.files[0];

    if (!image) {
      setAvatarUrl('')
      return;
    }

    image = await resizeFile(image)

    if (image.type == 'image/jpeg' || image.type == 'image/png' || image.type == 'image/jpg') {
      setImageAvatar(image)
      setAvatarUrl(URL.createObjectURL(image))
    } else{
      handleToast(true, "error", "Extensão inválida!")
    }
  }

  const resizeFile = async (file) =>
    new Promise((resolve) => {
      const fileName = file.name.split('.')
      Resizer.imageFileResizer(
        file,
        200,
        112.5,
        fileName[fileName.length - 1],
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "file"
      );
    });

  const deleteLogo = async (e) => {
    e.preventDefault()
    const body = new FormData();
    body.append("logo_img", "teste.png")
    body.append("profilePic", null)
    body.append("id_client", id)
    handleLoading(true); 
    try {
      const { data } = await api({
        method: "post",
        url: "/logo/upload",
        data: body
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    updateTable()
    handleClose()
  }

  return (
    <>
      <Box sx={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
        <CardSys>
          <Grid container>
            <Grid
              item
              sx={{ display: "flex" }}
              justifyContent="space-between"
              alignItems="center"
              xs={12}
            >
              <SubTitlePages sx={{ display: "flex" }}>
                <SubTitlePages sx={{ fontWeight: "bold", marginRight: "4px" }}>
                  Inserir logo
                </SubTitlePages>
              </SubTitlePages>
              <CloseButton onClick={handleClose}></CloseButton>

            </Grid>
            <Grid item xs={12}>
              <SubTitlePages sx={{ display: "flex" }}>
                {title}
              </SubTitlePages>
            </Grid>
          </Grid>
          <Grid container sx={{ overflowY: 'auto', maxHeight: "60vh", marginTop: "16px" }}>

            {avatarUrl ? (
              <>
                <Grid item xs={12} sx={{ display: "flex", marginBottom: "16px" }}
                  justifyContent="center"
                  alignItems="center">
                  <img src={avatarUrl} width={200} alt="logo"></img>
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", marginBottom: "16px" }}
                  justifyContent="center"
                  alignItems="center">
                  <Button onClick={deleteLogo} sx={{ textTransform: "initial", textDecoration: "underline", color: "#2c4992" }}>
                    Excluir
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sx={{ display: "flex" }}>
                  <InputFile onChange={handleFile}></InputFile>
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", marginBottom: "16px" }}>
                  <Typography>
                    Extensões aceitas: .png, .jpg, .jpeg
                  </Typography>
                </Grid>
              </>
            )}
          </Grid>
          <Grid container direction="row"
            justifyContent="center"
            alignItems="center">
            <Grid item>
              <CancelButton onClick={handleClose}>
              </CancelButton>
            </Grid>
            <Grid item>
              {imageAvatar ? (

              <ButtonSave sx={{ borderRadius: "10px" }}
                onClick={handleSubmit}
              >
                Salvar
              </ButtonSave>
              ): null}
            </Grid>
          </Grid>
        </CardSys>
      </Box >
    </>
  );
}
